import { Button, ButtonGroup, FormLayout, Modal, Stack } from "@shopify/polaris";
import { useCallback } from "react";
import { OPEN_MODAL_CREATE_ACTION } from "../../../constants/modalTypes.js";
import { closeModal } from "../../../store/features/modal.js";
import { Field, Form } from "react-final-form";
import ActionNameField from "./components/ActionNameField.js";
import { validate } from "./validate.js";
import { nextStep, updateActionData } from "../../../store/features/action.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";
import useHandleKeyDown from "../../../hooks/useHandleKeyDown.js";

const CreateActionModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType, modalData } = useAppSelector((state) => state.modal);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, []);

  const onSubmit = useCallback((data) => {
    dispatch(updateActionData({ type: modalData.actionType, name: data.actionName }));
    handleClose();
    dispatch(nextStep());
  }, [modalData]);

  const handleKeyDown = useHandleKeyDown();

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_CREATE_ACTION}
      onClose={handleClose}
      title="Create new action"
    >
      <Form
        onSubmit={onSubmit}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
            <Modal.Section>
              <FormLayout>
                <Field
                  name="actionName"
                  component={ActionNameField}
                />
              </FormLayout>
            </Modal.Section>
            <Modal.Section>
              <Stack distribution={"trailing"}>
                <ButtonGroup>
                  <Button
                    onClick={handleClose}
                  >
                    Go back
                  </Button>
                  <Button
                    primary
                    submit
                  >
                    Continue
                  </Button>
                </ButtonGroup>
              </Stack>
            </Modal.Section>
          </form>
        )}
      />
    </Modal>
  );
};

export default CreateActionModal;
